export class MenuButton {
  #showButton: HTMLButtonElement | null = null;
  #container: HTMLDialogElement | null = null;
  #closeButton: HTMLButtonElement | null = null;
  constructor() {
    this.#showButton = document.querySelector<HTMLButtonElement>(
      '#header-menu-mobile-button'
    );
    this.#container = document.querySelector<HTMLDialogElement>(
      '#header-menu-mobile-container'
    );
    this.#closeButton =
      this.#container?.querySelector<HTMLButtonElement>('.close-button') ??
      null;
  }
  init() {
    this.#showButton?.addEventListener('click', this.#showMenu);
    this.#closeButton?.addEventListener('click', this.#closeMenu);
    this.#container?.addEventListener('click', this.#handleContainerClick);
    this.#container?.addEventListener('cancel', this.#closeMenu);
    window.addEventListener('resize', this.#handleResize);
  }
  dispose() {
    this.#showButton?.removeEventListener('click', this.#showMenu);
    this.#closeButton?.removeEventListener('click', this.#closeMenu);
    this.#container?.removeEventListener('click', this.#handleContainerClick);
  }
  #showMenu = () => {
    this.#showButton?.setAttribute('aria-expanded', 'true');
    this.#container?.showModal();
    document.body.style.overflow = 'hidden';
  };
  #closeMenu = () => {
    this.#showButton?.setAttribute('aria-expanded', 'false');
    this.#container?.close();
    document.body.style.overflow = '';
  };
  #handleContainerClick = (event: MouseEvent) => {
    if (event.target === event.currentTarget) {
      this.#closeMenu();
    }
  };
  #handleResize = () => {
    if (window.innerWidth >= 768) {
      this.#closeMenu();
    }
  };
}
